// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"g2-z","colorTextValue":"h2-z","swatches":"i2-z","collapseLink":"j2-z","isCollapsed":"k2-z","dropdown":"l2-z","disabled":"m2-z"};